export const prestigeConfigurationQueryKey = (configId: string) =>
  ['prestigeConfiguration', configId] as const;

export const pricingConfigurationQueryKey = () =>
  ['pricingConfiguration'] as const;
